import { type RefObject, useEffect, useLayoutEffect, useState } from 'react'

const VIEWPORT_PART = 0.1

export function useVirtualPages(
	storageKey: string,
	total: number,
	nextRef: RefObject<HTMLDivElement>,
	perPage: number
) {
	const [count, setCount] = useState(0)

	const next = () => {
		setCount((prev) => {
			localStorage.setItem(
				`plp-pages-${storageKey}`,
				JSON.stringify({
					count: prev + perPage,
				})
			)
			return prev + perPage
		})
	}

	useEffect(() => {
		if (nextRef.current) {
			const storageValue = localStorage.getItem(`plp-pages-${storageKey}`)
			if (storageValue) {
				const fromStoragePages = JSON.parse(storageValue)
				if (fromStoragePages && fromStoragePages.count) {
					setCount(fromStoragePages.count)
				}
			}
		}
	}, [nextRef.current, setCount])

	useLayoutEffect(() => {
		const viewportMargin = window.innerHeight * VIEWPORT_PART
		const PaginationInterception = (entries: { isIntersecting: boolean }[]) => {
			const [entry] = entries
			if (entry.isIntersecting && count < total) {
				next()
			}
		}
		const observer = new IntersectionObserver(PaginationInterception, {
			rootMargin: `${viewportMargin}px 0px ${viewportMargin}px 0px`,
			threshold: 0,
		})
		if (nextRef.current) {
			observer.observe(nextRef.current)
		}
		return () => {
			if (observer && nextRef.current) {
				observer.unobserve(nextRef.current)
				observer.disconnect()
			}
		}
	}, [total, count, nextRef.current])

	return {
		count,
	}
}
